<template>

    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
        <v-card>
            <v-toolbar dark color="primary" style="position: sticky; top: 0; z-index: 1">
                <v-btn icon dark @click="close"><v-icon>mdi-close</v-icon></v-btn>
                <v-toolbar-title>Novo Beneficiário</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark text @click="save" :disabled="!valid">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>

            <v-card-text class="mt-5">
                <v-form id="formCadastroBeneficiario" ref="formCadastroBeneficiario" v-model="valid" lazy-validation >
                    <v-row>
                        <v-col cols="12" sm="4" md="3">
                            <v-row dense class="pa-4 pb-0" style="background: rgb(239, 242, 245) !important; border-radius: 10px !important;">
                                <v-col cols="12" class="mb-3" style="display: flex; align-items: center; justify-content: center;">
                                    <div v-if="fotoCarregada" style="justify-content: center ; display: flex">
                                        <v-img :src="fotoCarregada" max-width="160" max-height="155" contain/>
                                    </div>
                                    <v-skeleton-loader v-else width="160" height="155" type="image" v-bind="attrs = {boilerplate: true}" />
                                </v-col>
                                <v-col cols="12" class="py-0" style="margin-top: 0px !important; margin-bottom: 10px !important; text-align: center;">
                                    <span style="color: red">*O upload será realizado no momento da inclusão ou alteração.</span>
                                </v-col>
                                <v-col cols="12" class="py-0 d-flex align-center">
                                    <v-file-input accept=".jpg" show-size label="Foto" v-model="fotoEnviar" dense outlined/>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" sm="8" md="9" style="display: flex; align-items: flex-end;">
                            <v-row>
                                <v-col cols="12" sm="3" md="2">
                                    <v-text-field v-model="item.id" label="Código" readonly dense outlined/>
                                </v-col>
                                <v-col cols="12" sm="9" md="10">
                                    <v-text-field v-model="item.nome" label="Nome" :rules="fieldRules" :counter="80" maxlength="80" dense outlined/>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <v-select v-model="item.tipo" label="Tipo" :items="tipos" item-value="key" item-text="value" dense outlined/>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field v-model="item.cpfCnpj" :label="lblCpfCnpj" v-mask="mskCpfCnpj" counter="18" maxlength="18" @blur="item.cpfCnpj = (item.cpfCnpj || '').toLocaleUpperCase()" @change="VerificarExistente()" dense outlined/>
                                </v-col>
                                <v-col cols="12" sm="3">
                                    <v-text-field v-model="item.identidadeInscricaoEstadual" :label="lblIdentidadeInscricaoEstadual" :counter="15" maxlength="15" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field type="date" v-model="item.dataNascimentoFundacao" :label="lblNascimentoFundacao" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="item.dataNascimentoFundacao" no-title/>
                                    </v-menu>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-text-field v-model="item.idade" label="Idade" disabled dense outlined/>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="item.telefone" label="Telefone" v-mask="mskTelefone" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="3">
                                    <v-text-field v-model="item.celular" label="Celular" v-mask="mskTelefone" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="4">
                                    <v-text-field v-model="item.email" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                                </v-col>
                                <v-col cols="12" md="2">
                                    <v-menu :close-on-content-click="false" transition="scale-transition" offset-y min-width="290px" max-width="290px">
                                        <template v-slot:activator="{on}">
                                            <v-text-field v-model="item.dataAdesao" type="date" label="Data Adesão" :rules="fieldRules" dense outlined>
                                                <template v-slot:prepend>
                                                    <v-icon v-on="on">mdi-calendar</v-icon>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <v-date-picker locale="pt-br" v-model="item.dataAdesao" no-title/>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row class="mt-2">
                        <v-col cols="12" md="3">
                            <v-text-field v-model="item.cep" label="CEP" v-mask="mskCep" @change="ObterEndereco(item.cep)" :append-icon="item.latitude != 0 ? 'mdi-map-marker' : ''" @click:append="AbrirMapa()" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="item.logradouro" label="Logradouro" :counter="80" maxlength="80" dense outlined/>
                        </v-col>                        
                        <v-col cols="12" md="3">
                            <v-text-field v-model="item.bairro" label="Bairro" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.cidade" label="Cidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-select v-model="item.estado" label="Estado" :items="estados" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field v-model="item.pais" label="País" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.sexo" label="Sexo" :items="sexos" item-value="key" item-text="value" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.naturalidade" label="Naturalidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.nacionalidade" label="Nacionalidade" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.estadoCivil" label="Estado Civil" :items="estadoCivis" item-value="key" item-text="value" :rules="fieldRules" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-text-field v-model="item.matricula" label="Matrícula" :counter="45" maxlength="45" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="2">
                            <v-select v-model="item.etnia" label="Etnia/Cor" :items="etnias" item-value="key" item-text="value" dense outlined/>
                        </v-col>
                    </v-row>

                    <fieldset class="pa-4">
                        <legend>Dados do Responsável</legend>

                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.pai" label="Pai" :counter="80" maxlength="80" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.telefonePai" label="Telefone" v-mask="mskTelefone" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.celularPai" label="Celular" v-mask="mskTelefone" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.emailPai" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.mae" label="Mãe" :counter="80" maxlength="80" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.telefoneMae" label="Telefone" v-mask="mskTelefone" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.celularMae" label="Celular" v-mask="mskTelefone" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.emailMae" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="item.responsavel" label="Responsável" :counter="60" maxlength="60" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.parentescoResp" label="Parentesco" :counter="20" maxlength="20" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.telefoneResp" :label="isTelefoneResp ? 'Telefone' : 'CPF'" v-mask="respMask" :prepend-icon="isTelefoneResp ? 'mdi-phone-refresh' : 'mdi-file-document-refresh'" @click:prepend="AlterarTipoTelefoneResponsavel()" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="2">
                                <v-text-field v-model="item.celularResp" label="Celular" v-mask="mskTelefone" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="item.emailResp" label="E-mail" :counter="60" maxlength="60" dense outlined/>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="3">
                                <v-text-field v-model="item.cepResp" label="CEP" v-mask="mskCep" @change="ObterEnderecoResponsavel(item.cepResp)" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="5">
                                <v-text-field v-model="item.logradouroResp" label="Logradouro" :counter="80" maxlength="80" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.bairroResp" label="Bairro" :counter="45" maxlength="45" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.cidadeResp" label="Cidade" :counter="45" maxlength="45" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select v-model="item.estadoResp" label="Estado" :items="estados" item-value="key" item-text="value" dense outlined/>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field v-model="item.paisResp" label="País" :counter="45" maxlength="45" dense outlined/>
                            </v-col>
                        </v-row>

                    </fieldset>

                    <v-row>
                        <v-col cols="12" md="12">
                            <v-textarea v-model="item.observacao" label="Observação" :counter="255" maxlength="255" dense outlined/>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo01">
                            <v-text-field v-model="item.campo01" :label="parametro.beneficiarioCampo01" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo02">
                            <v-text-field v-model="item.campo02" :label="parametro.beneficiarioCampo02" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo03">
                            <v-text-field v-model="item.campo03" :label="parametro.beneficiarioCampo03" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo04">
                            <v-text-field v-model="item.campo04" :label="parametro.beneficiarioCampo04" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo05">
                            <v-text-field v-model="item.campo05" :label="parametro.beneficiarioCampo05" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo06">
                            <v-text-field v-model="item.campo06" :label="parametro.beneficiarioCampo06" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo07">
                            <v-text-field v-model="item.campo07" :label="parametro.beneficiarioCampo07" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo08">
                            <v-text-field v-model="item.campo08" :label="parametro.beneficiarioCampo08" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo09">
                            <v-text-field v-model="item.campo09" :label="parametro.beneficiarioCampo09" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo10">
                            <v-text-field v-model="item.campo10" :label="parametro.beneficiarioCampo10" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo11">
                            <v-text-field v-model="item.campo11" :label="parametro.beneficiarioCampo11" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo12">
                            <v-text-field v-model="item.campo12" :label="parametro.beneficiarioCampo12" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo13">
                            <v-text-field v-model="item.campo13" :label="parametro.beneficiarioCampo13" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo14">
                            <v-text-field v-model="item.campo14" :label="parametro.beneficiarioCampo14" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12" md="6" v-if="parametro.beneficiarioCampo15">
                            <v-text-field v-model="item.campo15" :label="parametro.beneficiarioCampo15" :counter="50" maxlength="50" dense outlined/>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
        </v-card>

        <mapa v-model="dialogMapa" :item="coordenadas" @fechou="dialogMapa = false" @salvou="Listar()"/>

        <v-overlay :value="salvando">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

    </v-dialog>

</template>
<script>
import { MskCpf, MskCnpjAlfa, MskTelefone, MskCep } from '@/core/domain/shared/Global';
import BeneficiarioService from '../../../core/services/projetos/BeneficiarioService';
import Beneficiario from '../../../core/domain/projetos/Beneficiario';
import Parametro from '../../../core/domain/geral/Parametro';
import {ParametroService, EstadoEnumService, TipoPessoaEnumService, EtniaEnumService, SexoEnumService, EstadoCivilEnumService, EnderecoService } from '../../../core/services/geral';

export default {
    props:{
        item: {
            required: true
        },
        value: {}
    },
    watch: { 
        item: function() { 
            if ('formCadastroBeneficiario' in this.$refs)
                this.$refs.formCadastroBeneficiario.resetValidation();
            
            if(this.item.id > 0){
                this.service.Foto(this.item.id).then(
                    res=>{
                        this.fotoCarregada = res.data;
                    }
                )

                this.isTelefoneResp = !this.item.telefoneResp.includes(".");

                if(this.isTelefoneResp){
                    this.respMask = MskTelefone;
                }
                else{
                    this.respMask = MskCpf;
                }
            }
        },
        value: function() {
            this.dialog = this.value;
        },
        dialog:  function() {
            if (!this.dialog) {
                this.$emit('fechou');
            }
        },
        'item.tipo': {
            handler: function (val) {
                if (val === 0){
                    this.mskCpfCnpj = MskCpf;
                    this.lblCpfCnpj = 'CPF';
                    this.lblIdentidadeInscricaoEstadual = 'Identidade';
                    this.lblNascimentoFundacao = 'Nascimento';
                }
                else {
                    this.mskCpfCnpj = MskCnpjAlfa;
                    this.lblCpfCnpj = 'CNPJ';
                    this.lblIdentidadeInscricaoEstadual = 'Inscrição Estadual';
                    this.lblNascimentoFundacao = 'Fundação';
                }

            },
            deep: true
        },
        'item.dataNascimentoFundacao': {
            handler: function (val) {
                if(val){
                    var partes = val.split("/");
                    var junta = partes[2]+"-"+partes[1]+"-"+partes[0];
                    var dob = new Date(junta);
                    var currentDate = new Date();
                    var currentYear = currentDate.getFullYear();
                    var birthdayThisYear = new Date(currentYear, dob.getMonth(), dob.getDate());
                    var age = currentYear - dob.getFullYear();
                    if(birthdayThisYear > currentDate) {
                        age--;
                    }
                    this.item.idade = age;
                }
            },
            deep: true
        },
    },
    data: () => ({
        service: new BeneficiarioService(),
        mskCpfCnpj: MskCpf,
        mskTelefone: MskTelefone,
        mskCep: MskCep,
        lblCpfCnpj: 'CPF',
        lblIdentidadeInscricaoEstadual: 'Identidade',
        lblNascimentoFundacao: 'Nascimento',
        valid: true,
        dialog: false,
        isLoading: false,
        parametro: new Parametro(),
        tipos: [],
        estados: [],
        etnias: [],
        sexos: [],
        estadoCivis: [],
        fieldRules: [
            v => !!v || 'Campo obrigatório'
        ],
        sessionApp: {},
        fotoCarregada:null,
        fotoEnviar:null,
        salvando: false,
        isTelefoneResp: true,
        respMask: undefined,
        dialogMapa: false,
        coordenadas: []
    }),
    methods: {
        VerificarExistente(){
            this.service.VerificarExistente(this.item.cpfCnpj).then(
                res => {
                    let resposta = res.data;
                    if(resposta){
                        this.item.cpfCnpj = "";
                        this.$swal('Aviso', "Já existe um Beneficiário com esse CPF/CNPJ cadastrado.", 'warning')
                    }
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
        },
        save() {

            if (this.$refs.formCadastroBeneficiario.validate()) {
                
                this.salvando = true;

                let modelo = new Beneficiario(this.item);

                this.service.Salvar(modelo).then(
                    res => {

                        if(this.fotoEnviar){
                            this.EnviarDocumento(res.data.id ? res.data.id : this.item.id).then(() =>{
                                this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                                this.$emit('salvou');
                                this.close();
                            });
                        }
                        else{
                            this.$swal('Aviso', 'Operação realizada com sucesso!', res.status == 201 || res.status == 200 ? 'success' : 'warning');
                            this.$emit('salvou');
                            this.close();
                        }

                    }, 
                    err =>  {
                        if (err.response.status == 400) {
                            this.$swal('Aviso', err.response.data.title, 'warning')    
                        }
                        else {
                            this.$swal('Aviso', err.response.data, 'error')
                        }
                    }
                ).finally(() => {
                    this.salvando = false;
                })
            }
        },
        close() {
            this.coordenadas = [];
            this.fotoCarregada = null;
            this.fotoEnviar = null;
            this.dialog = false;
            location.reload();
        },
        async EnviarDocumento(id){
            
            return new Promise(async (resolve, reject) => {

                let arquivo = await this.Ler(this.fotoEnviar);

                this.service.EnviarDocumento(id, arquivo).then(
                    res => resolve(res),
                    err => reject(err)
                )

            });

        },
        async Ler(arquivo){
            return new Promise((resolve, reject) => {
                let fr = new FileReader();
            
                fr.onload = (arquivo) => {
                    resolve(arquivo.target.result);
                };
            
                fr.readAsArrayBuffer(arquivo);
            });
        },
        ObterEndereco(cep){
            const enderecoService = new EnderecoService();
            enderecoService.ObterPorCep(cep)
            .then(
                res => {
                    let endereco = res.data;
                    if (endereco) {
                        this.item.logradouro = endereco.logradouro;
                        this.item.bairro = endereco.bairro;
                        this.item.cidade = endereco.municipio;
                        this.item.estado = endereco.estado;
                        this.item.pais = endereco.pais;
                    }
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        },
        ObterEnderecoResponsavel(cep){
            const enderecoService = new EnderecoService();
            enderecoService.ObterPorCep(cep)
            .then(
                res => {
                    let endereco = res.data;
                    if (endereco) {
                        this.item.logradouroResp = endereco.logradouro;
                        this.item.bairroResp = endereco.bairro;
                        this.item.cidadeResp = endereco.municipio;
                        this.item.estadoResp = endereco.estado;
                        this.item.paisResp = endereco.pais;
                    }
                },
                err => {
                    this.$swal('Aviso', err.message, 'error');
                }
            );
        },
        AlterarTipoTelefoneResponsavel(){
            this.isTelefoneResp = !this.isTelefoneResp;
            if(this.isTelefoneResp){
                this.respMask = MskTelefone;
            }
            else{
                this.respMask = MskCpf;
            }
        },
        AbrirMapa()
        {
            let model = {
                id: this.item.id,
                nome: this.item.nome,
                latitude: this.item.latitude,
                longitude: this.item.longitude
            }
            this.coordenadas.push(model);
            this.dialogMapa = true;
        }
    },
    beforeUpdate(){
        if (!this.dialog){
            this.$emit('fechou');
        }
    },
    mounted() {
        
        let parametroService = new ParametroService();
        parametroService.ObterPorId(1)
            .then(
                res => {
                    this.parametro = new Parametro(res.data);
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let tipoEnumService = new TipoPessoaEnumService();
        tipoEnumService.Listar()
            .then(
                res => {
                    this.tipos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let estadoEnumService = new EstadoEnumService();
        estadoEnumService.Listar()
            .then(
                res => {
                    this.estados = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let etnianumService = new EtniaEnumService();
        etnianumService.Listar()
            .then(
                res => {
                    this.etnias = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let sexonumService = new SexoEnumService();
        sexonumService.Listar()
            .then(
                res => {
                    this.sexos = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );

        let estadoCivilEnumService = new EstadoCivilEnumService();
        estadoCivilEnumService.Listar()
            .then(
                res => {
                    this.estadoCivis = res.data;
                },
                err => {
                    this.$swal('Aviso', err.message, 'error')}
            );
        
    }
}
</script>
